"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import _ from "underscore";
import Blocker from "./blocker";
import React from "react";
export default class WaitingSpinner extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "spinnerBar", (index) => {
      return /* @__PURE__ */ React.createElement("div", { className: "bar" + (index + 1), key: index });
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      Blocker,
      {
        "data-component": "WaitingSpinner",
        modalView: this.props.when ? this.spinner() : void 0,
        children: this.props.children
      }
    );
  }
  spinner() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-sign show_for_non_reskin" }, /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-spinner" }, _.map(_.range(12), this.spinnerBar)), /* @__PURE__ */ React.createElement("div", { className: "cg-busy-default-text" }, "Please Wait...")), /* @__PURE__ */ React.createElement("div", { className: "v3-spinner-container show_for_reskin" }, /* @__PURE__ */ React.createElement(
      "svg",
      {
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        className: "v3-spinner"
      },
      /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1273_124830" }, /* @__PURE__ */ React.createElement("rect", { width: "64", height: "64", fill: "white" }))),
      /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1273_124830)" }, /* @__PURE__ */ React.createElement(
        "path",
        {
          className: "v3-spinner-quadrant-1",
          d: "M57.6926 23.1432L40.8009 23.1432L40.8009 6.25149L34.5466 0L34.5466 29.3983L63.9448 29.3983L57.6926 23.1432Z",
          fill: "white"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          className: "v3-spinner-quadrant-2",
          d: "M57.6926 40.8041L40.8009 40.8041L40.8009 57.6966L34.5466 63.9481L34.5466 34.5498L63.9448 34.5498L57.6926 40.8041Z",
          fill: "white"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          className: "v3-spinner-quadrant-3",
          d: "M6.25149 23.1432L23.1432 23.1432L23.1432 6.25149L29.3983 0L29.3983 29.3983L0 29.3983L6.25149 23.1432Z",
          fill: "#00A4BF"
        }
      ), /* @__PURE__ */ React.createElement(
        "path",
        {
          className: "v3-spinner-quadrant-4",
          d: "M6.25149 40.8041L23.1432 40.8041L23.1432 57.6966L29.3983 63.9481L29.3983 34.5498L0 34.5498L6.25149 40.8041Z",
          fill: "white"
        }
      ))
    )));
  }
}
__publicField(WaitingSpinner, "defaultProps", {
  children: /* @__PURE__ */ React.createElement("div", null)
});
